/** Placeholder values pending final copy and redirect target. */
export const OPS_TECH_MESSAGE =
  "Laptop replacements for Operations employees are handled through your local IT support process.";
export const OPS_TECH_LINK_LABEL = "Go to IT support";
export const OPS_TECH_URL = "https://it.amazon.com";
